const isDevelopment = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';

const readPublicApiUrl = () =>
  process.env.PUBLIC_API_URL || (typeof window !== 'undefined' && window.PUBLIC_API_URL) || '';

const isStagingLike = () => {
  const apiUrl = readPublicApiUrl().toLowerCase();
  const hostname =
    typeof window !== 'undefined' && window.location?.hostname
      ? window.location.hostname.toLowerCase()
      : '';

  // Check if the hostname or API URL contains "staging" or "stagingdemo" to identify staging-like environments.
  const hostLooksStaging =
    hostname.startsWith('staging') ||
    hostname.includes('.staging.') ||
    hostname.includes('stagingdemo');
  const apiLooksStaging = apiUrl.includes('/staging/') || apiUrl.includes('/stagingdemo/');

  return hostLooksStaging || apiLooksStaging;
};

const readVoipFlagValue = () =>
  process.env.PUBLIC_ENABLE_RESPONDER_VOIP ||
  process.env.REACT_APP_ENABLE_RESPONDER_VOIP ||
  (typeof window !== 'undefined' &&
    (window.PUBLIC_ENABLE_RESPONDER_VOIP || window.REACT_APP_ENABLE_RESPONDER_VOIP)) ||
  '';

const readMessengerFlagValue = () =>
  process.env.PUBLIC_ENABLE_RESPONDER_MESSENGER ||
  process.env.REACT_APP_ENABLE_RESPONDER_MESSENGER ||
  (typeof window !== 'undefined' &&
    (window.PUBLIC_ENABLE_RESPONDER_MESSENGER || window.REACT_APP_ENABLE_RESPONDER_MESSENGER)) ||
  '';

export const isResponderVoipEnabled = () => {
  return true;
  const isAllowedEnvironment = isDevelopment || isStagingLike();
  if (!isAllowedEnvironment) return false;

  const explicit = readVoipFlagValue().trim().toLowerCase();
  if (explicit === 'true') return true;
  if (explicit === 'false') return false;

  // Default on for allowed environments unless explicitly disabled.
  return true;
};

export const isResponderMessengerEnabled = () => true;
// readMessengerFlagValue().trim().toLowerCase() === 'true';
